import { useParams } from "react-router-dom";
import { portalLinks } from "./PortalLink";
import { RightArrowIcon } from "../../../components/common/Icons";
import { DefaultSystemBrowserOptions, InAppBrowser } from "@capacitor/inappbrowser";
import { useGetMobileLandingPagesQuery } from "../../../app/services/portal";
import { useEffect, useState } from "react";

const HomeInnerComponent = () => {
    const { id } = useParams();
    const [data, setData] = useState<any[]>([]);


    const { data: landingData } = useGetMobileLandingPagesQuery();
    useEffect(() => {
        if (landingData) {
            setData(landingData);
        }
    }, [landingData]);
    const links = data?.find(x => x.id?.toString() === id)?.subLinks;
    const open_with_inapp_browser = async (link: string) => {
        console.log("link ", link)
        await InAppBrowser.openInSystemBrowser({
            url: link,
            options: DefaultSystemBrowserOptions
        }).then((res) => {
            const url = window.location;
            console.log("res", res, url)
        });
    }
    console.log("links ",links)
    return <div className="px-5">
        <ul className="grid grid-cols-2 gap-[10px]">
            {links?.map((link: any, key: number) => {
                return <li key={key}>
                    <button onClick={() => open_with_inapp_browser(link.link)} className="px-3 py-4 bg-sat_lightgray rounded-4 block w-full">
                        <img src={link.logo} alt={link.name} className="w-[30px] mx-auto object-contain aspect-square rounded-[2px]" />
                        <div className="flex mt-[10px] justify-between items-center">
                            <p className="text-button font-bold leading-[normal] text-darkblackv2 text-center w-full">{link.name}</p>
                            {/* <RightArrowIcon /> */}
                        </div>
                    </button>
                </li>
            })}
        </ul>
    </div>
}
export default HomeInnerComponent;